import React, { Component } from 'react';
import T from 'prop-types';
// shapes
import inputStep from '../../../shapes/inputStep';
// components
import CheckBox from '../../../components/CheckBox/CheckBox';
import FieldError from '../../../components/Form/FieldError';
// styles
import styles from './CheckBoxInput.mod.css';
import classnames from 'classnames/bind';

const cn = classnames.bind(styles);

class CheckBoxInput extends Component {
  handleChange = id => {
    const {
      data: {
        content: { questions }
      },
      values,
      setFieldValue
    } = this.props;

    if (!values[id]) {
      setFieldValue(id, true);
      questions.forEach(item => {
        if (!values[item.id] && item.id !== id) {
          setFieldValue(item.id, false);
        }
      });
    }
    if (values[id]) {
      setFieldValue(id, false);
      const hasSelected = questions.find(
        item => values[item.id] && item.id !== id
      );
      !hasSelected && questions.forEach(item => setFieldValue(item.id, null));
    }
  };

  getError = () => {
    const {
      errors,
      data: {
        content: { questions }
      }
    } = this.props;

    const hasError = !!questions.find(({ id }) => errors[id]);
    return hasError ? 'Please, select at least one answer!' : '';
  };

  getGroupsPercent = () => {
    const {
      values,
      data: { content }
    } = this.props;

    const withGroups = content.question_set_type === 'hidden_answers';

    if (!withGroups) return null;

    const groups = {};
    content.questions.forEach(
      question => (groups[question.additional_info] = [])
    );

    content.questions.forEach(
      question =>
        (groups[question.additional_info] = [
          ...groups[question.additional_info],
          question.id
        ])
    );

    const groupInPercent = {};
    for (const groupName of Object.keys(groups)) {
      let percent = 0;
      const total = groups[groupName].length;
      groups[groupName].forEach(answerId => {
        if (values[answerId]) percent += 100 / total;
      });
      groupInPercent[groupName] = percent;
    }

    return groupInPercent;
  };

  render() {
    const {
      data: {
        content: { questions, view_type }
      },
      values
    } = this.props;

    const error = this.getError();
    const isButtonView = view_type === 'block';
    const groupPercent = this.getGroupsPercent();

    return (
      <div className={cn('wrapper', { horizontal: isButtonView })}>
        {questions.map(({ title, id }) => (
          <CheckBox
            key={'' + id + values[id]}
            name={id}
            isButtonView={isButtonView}
            className={cn('checkbox')}
            label={title}
            checked={values[id]}
            onChange={() => this.handleChange(id)}
          />
        ))}
        {groupPercent &&
          Object.keys(groupPercent).map((groupName, index) => (
            <div className={cn('answersByGroup')} key={index}>
              <span>{groupName}:</span>
              {groupPercent[groupName]}%
            </div>
          ))}
        <FieldError error={error} touched={true} />
      </div>
    );
  }
}

CheckBoxInput.propTypes = {
  data: inputStep,
  setFieldValue: T.func.isRequired,
  values: T.object.isRequired
};

export default CheckBoxInput;



// WEBPACK FOOTER //
// ./src/containers/Module/components/CheckBoxInput.jsx